import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articlesByCategory } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function CategoryOverview() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            内容板块
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            四大核心板块，全方位解读「好色小姨」这一经典角色
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {categories.map((cat) => {
            const catArticles = articlesByCategory[cat.slug] || [];
            return (
              <div key={cat.slug} className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                <div className="flex items-start gap-4 mb-5">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                    cat.color === 'primary' ? 'bg-primary-100/70 text-primary-500' :
                    cat.color === 'accent' ? 'bg-accent-100/70 text-accent-500' :
                    'bg-secondary-100/70 text-secondary-500'
                  }`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <Link to={`/category/${cat.slug}`} className="group">
                      <h3 className="text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200" style={{ fontFamily: 'var(--font-heading)' }}>
                        {cat.name}
                      </h3>
                    </Link>
                    <p className="text-sm text-foreground-600 mt-1 line-clamp-2">{cat.description}</p>
                  </div>
                </div>

                <div className="space-y-3">
                  {catArticles.slice(0, 2).map((article) => (
                    <ArticleCard key={article.slug} article={article} variant="compact" />
                  ))}
                </div>

                <Link
                  to={`/category/${cat.slug}`}
                  className="inline-flex items-center gap-1 mt-4 text-sm text-primary-500 hover:text-primary-600 font-medium"
                >
                  查看全部 {cat.articleCount} 篇文章 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}